import toPhysicalAddress from 'owa-location-card-v2/lib/utils/postalAddressConverter';
import toCoordinate from 'owa-location-card-v2/lib/utils/coordinatesConverter';
import { initializePlace } from 'owa-location-card-v2/lib/actions/locationCardActions';
import { setPlace } from 'owa-location-card-v2/lib/mutators/locationCardMutators';
import { orchestrator } from 'satcheljs';

/**
 * Initialize the place in the store
 */
export default orchestrator(initializePlace, async actionMessage => {
    const { name, postalAddress, locationId, locationType, phoneNumber } = actionMessage;
    setPlace({
        Id: locationId,
        Name: name,
        Type: locationType ? locationType : 'Unknown',
        EmailAddress: undefined,
        Address: toPhysicalAddress(postalAddress),
        Coordinates: toCoordinate(postalAddress),
        PhoneNumber: phoneNumber,
        ResourceDetails: undefined,
        PlaceDetails: undefined,
    });
});
